import axios from 'axios';
import { getCookie } from './cookie';

const token = getCookie('csrfToken');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}
axios.defaults.headers.common['Accept'] = 'application/json, text/javascript'
axios.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest'

export default axios;